import { render, staticRenderFns } from "./EstimateNotesModal.vue?vue&type=template&id=b4aac226&scoped=true"
import script from "./EstimateNotesModal.vue?vue&type=script&lang=js"
export * from "./EstimateNotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aac226",
  null
  
)

export default component.exports